
import './ExportEnforcePopup.css';
import React from 'react';
import Spinner from './Spinner'

interface WarningBoxProps {
  //isOpen: boolean;
  onCloseWarning: () => void;
  onExport: () => void;
  onCancel: () => void;
  isExporting: boolean;
}

const ExportEnforcePopup: React.FC<WarningBoxProps> = ({ onCloseWarning, onExport, onCancel, isExporting }) => {
   
// if (!isOpen) return null;

 return (
  <div className="warning-overlay">
    <div className="warning-container">
      <button className="warningclose-btn" onClick={onCloseWarning}>×</button>
      {/* Line 1: Warning Icon */}
      <div className="warning-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="48.718" height="45.673" viewBox="0 0 48.718 45.673">
            <g id="Group_8960" data-name="Group 8960" transform="translate(0 -10045.48)">
                <g id="exclamation-mark_15674336" transform="translate(0 10045.48)">
                <path id="Path_2549" data-name="Path 2549" d="M3030.909,12.1a7.171,7.171,0,0,0-12.622,0c-5.038,9.05-12.061,21.663-17.084,30.684a7.689,7.689,0,0,0,.016,7.485,7.238,7.238,0,0,0,6.3,3.738h34.167a7.241,7.241,0,0,0,6.3-3.738,7.691,7.691,0,0,0,.015-7.485L3030.909,12.1Zm-3.99,2.222L3044,45A3.115,3.115,0,0,1,3044,48.03a2.68,2.68,0,0,1-2.314,1.41h-34.167a2.68,2.68,0,0,1-2.314-1.41,3.113,3.113,0,0,1-.007-3.025l17.084-30.683a2.606,2.606,0,0,1,4.642,0Z" transform="translate(-3000.239 -8.334)" fill="#ffba08" fill-rule="evenodd"/>
                <path id="Path_2550" data-name="Path 2550" d="M3123.368,101.809a2.284,2.284,0,1,1-2.284,2.284A2.284,2.284,0,0,1,3123.368,101.809Zm2.184-18.271a2.187,2.187,0,1,0-4.37,0c.159,3.63.464,10.625.6,13.706a1.589,1.589,0,0,0,1.587,1.52h0a1.588,1.588,0,0,0,1.588-1.52C3125.089,94.163,3125.394,87.168,3125.551,83.538Z" transform="translate(-3099.008 -67.935)" fill="#ffba08" fill-rule="evenodd"/>
                </g>
            </g>
            </svg>
      </div>

      {/* Line 2: Important Label */}
      <div className="warning-title">Important</div>

      {/* Line 3: Message Label */}
      <div className="warning-message">
        Please export the existing city list<br></br>before proceeding with import.</div>

      {/* Line 4 & 5: Buttons */}
      <div>
        <button className="export-button" onClick={onExport}
        disabled={isExporting}
        >
          {isExporting && <Spinner />}
          {isExporting ? 'Exporting...' : 'Export Now'}
          </button>
      </div>
       <div>
            <button className="export-cancel" onClick={onCancel}>Cancel</button>
       </div>
    </div>
    </div>
  );
};

export default ExportEnforcePopup;
